import styled from 'styled-components';
import FAQ from './FAQ';

import Footer from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import TermsModal from '../../components/Modals/TermsModal';
import { useNavigate } from 'react-router-dom';
import TopBarInLandingPage from '../../components/common/TopBar/TopBarInLandingPage';
import NewCTAButton from './NewCTAButton';
import TitlesSection from './TitlesSection';
import CommunityImagesSection from './CommunityImagesSection';
import ContentSection from './ContentSection';
import {
  sectionContentLandingPage,
  sectionContentLandingPage2,
  sectionContentLandingPage3,
} from '../FeaturePages/featurePagesContent';
import FirstTimeUserStorage from '../../localStorage/firstTimeUserStorage';
import LoadingToShowWhileRedirecting from './LoadingToShowWhileRedirecting';
import { useGeneralContext } from '../../context/GeneralContextProvider';
import { desktopMediaQuery } from '../../styleHelpers';
import { HOME_PATH } from '../../pathNames';
import { SectionSeparator } from './SectionSeparator';
import InputBoxInLandingPage from './GeneratorInLandingPage';
import { setHasAcceptedTerms } from '../../components/helpers';

const LandingPage = () => {
  const { hasVisitedMainApp } = useGeneralContext();
  const [isStandaloneMode, setIsStandaloneMode] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  // hackish way to redirect to app and not show landing page on "app"
  useEffect(() => {
    const isStandalone = () => {
      return (
        (window.navigator as any).standalone === true ||
        window.matchMedia('(display-mode: standalone)').matches
      );
    };

    if (isStandalone()) {
      window.location.href = '/app';
    } else {
      setIsStandaloneMode(false);
    }
  }, []);

  useEffect(() => {
    const firstTimeUserStorage = new FirstTimeUserStorage();
    const hasVisitedBefore = firstTimeUserStorage.hasChecked();
    // if they have already visited this session, then allow them to go to landing page
    if (hasVisitedMainApp) return;

    // if first time user, show landing page
    if (!hasVisitedBefore) return;

    // redirect to app itself immediately if returning user
    setShowLogo(true);
    navigate(HOME_PATH);
  }, []);

  useEffect(() => {
    // Add styles via a hackish way
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = '/LandingPage.css';
    document.head.appendChild(styleLink);

    // remove when not in landing page
    return () => {
      document.head.removeChild(styleLink);
    };
  }, []);

  const [showFirstTimeModal, setShowFirstTimeModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    //@ts-ignore automatically zoom out to fix mobile issues
    document.body.style.zoom = 1;

    window.scrollTo(0, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAcceptAndClose = () => {
    setHasAcceptedTerms();
    setShowFirstTimeModal(false);
  };

  if (isStandaloneMode) {
    return null;
  }

  if (showLogo) {
    return <LoadingToShowWhileRedirecting />;
  }

  return (
    <>
      <Container>
        <TopBarInLandingPage />

        <FirstViewContainer className="fullViewResponsiveContainer">
          <TitlesSection />
          <NewCTAButton />
        </FirstViewContainer>

        <ContentSection {...sectionContentLandingPage} />

        <InputBoxInLandingPage />

        <ContentSection {...sectionContentLandingPage2} flipCard />
        <SectionSeparator />

        <CommunityImagesSection />

        <ContentSection {...sectionContentLandingPage3} />

        <SectionSeparator />

        <FAQ />

        <SectionSeparator />

        <Footer setShowFirstTimeModal={setShowFirstTimeModal} />
      </Container>
      <TermsModal
        showModal={showFirstTimeModal}
        handleAcceptAndClose={handleAcceptAndClose}
      />
    </>
  );
};

/*
<SocialButtonsContainer>
<DiscordLogo />
<RedditLogo />
<TwitterLogo />
</SocialButtonsContainer>

const SocialButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
`;
*/

// eslint-disable-next-line @typescript-eslint/no-unused-vars

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 95vw;
  margin: 8px;
  margin-top: 16px;
`;

const FirstViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 85vh;
  margin-top: 60px;

  ${desktopMediaQuery} {
    height: 90vh;
  }
`;

export default LandingPage;
